module.exports = __webpack_public_path__ + "e581c6957aba2220568f30c76ffafbb3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room3/audio2/03_2MCA Das Zimmer.mp3
// module id = 774
// module chunks = 0